import { parseEntity } from '@/shared/converters/commonConverters';
import { DateTimeFormat, parseMoment } from '@/shared/converters/dateConverters';
import { parseVehicle } from '@/vehicle/converters/vehicleConverters';
import DossierDetails from '../models/DossierDetails';
import { parsePlannerConfirmations } from './plannerConfirmationConverters';

const SCHEMA = {
  id: 'id',
  status: 'status',
  outletDescription: 'moboOutletDescription',
  workshopTeam: 'workshopTeam',
  externalReference: 'externalReference',
  object: (data: any) => parseVehicle(data.object),
  keyLabel: 'keyLabel',
  cleaningStatus: 'cleaningStatus',
  waitsOnPremise: 'waitsOnPremise',
  preferredPickUp: (data: any) => parseMoment(data.preferredPickUp, DateTimeFormat.LEGACY),
  checkedInAt: (data: any) => parseMoment(data.checkedInAt),
  dropOff: 'dropOff',
  appointment: (data: any) => parseMoment(data.appointment, DateTimeFormat.LEGACY),
  jobDescriptions: 'jobs',
  mobilitySolutionDescription: 'mobilitySolutionDescription',
  mobilitySolutionReference: 'mobilitySolutionReference',
  contact: 'contact',
  confirmations: (data: any) => parsePlannerConfirmations(data.confirmations),
  duration: 'duration',
};

export function parseDossierDetails(data: any): DossierDetails | null {
  return parseEntity(data, SCHEMA, DossierDetails);
}
